import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function useBootstrapBackdropFix() {
  const location = useLocation();

  const cleanup = () => {
    // Don't interfere while a Bootstrap component is open
    if (
      document.querySelector(".modal.show") ||
      document.querySelector(".offcanvas.show")
    ) {
      return;
    }

    const backdrops = document.querySelectorAll(
      ".modal-backdrop, .offcanvas-backdrop",
    );

    // Nothing to fix
    if (!backdrops.length) return;

    // Remove orphaned backdrops
    backdrops.forEach((el) => el.remove());

    // Restore body state
    document.body.classList.remove("modal-open");
    document.body.style.removeProperty("overflow");
    document.body.style.removeProperty("padding-right");
  };

  useEffect(() => {
    const handleHidden = () => {
      // Wait until Bootstrap finishes updating the DOM
      requestAnimationFrame(() => {
        requestAnimationFrame(cleanup);
      });
    };

    document.addEventListener("hidden.bs.modal", handleHidden);
    document.addEventListener("hidden.bs.offcanvas", handleHidden);

    return () => {
      document.removeEventListener("hidden.bs.modal", handleHidden);
      document.removeEventListener("hidden.bs.offcanvas", handleHidden);
    };
  }, []);

  useEffect(() => {
    requestAnimationFrame(() => {
      requestAnimationFrame(cleanup);
    });
  }, [location.pathname]);
}
